export default stream
export const {
  Duplex,
  PassThrough,
  Readable,
  Stream,
  Transform,
  Writable,
} = stream